<template>
  <div className="flex flex-col items-center">
    <h1 data-testid="landing-title" className="mb-3 font-bold text-center sm:text-3xl dark:text-zinc-500">{{ currentPage?.title }}</h1>

    <p className="max-w-xl mb-10 text-xl text-center dark:text-zinc-500 px-2">
      {{ currentPage?.description }}
    </p>

    <iframe
      v-if="currentPage?.video"
      :src="currentPage?.video"
      allowtransparency="true"
      allowfullscreen
      style="border: medium none"
      :data-frame-src="currentPage?.video"
      frameborder="0"
      class="w-full sm:rounded-lg aspect-video sm:w-144"
    />

    <div className="flex flex-col items-center gap-2 mt-10">
      <Button data-testid="landing-button-signup" type="solid" variant="blue" icon="general.stars" @click.stop.prevent="signUpClick()"
        >Get Zight for Free</Button
      >
      <Button
        data-testid="landing-button-learnMore"
        type="link"
        variant="black"
        icon="general.lightBulb"
        class="mt-2"
        target="_blank"
        :href="currentPage?.learMoreLink"
        >{{ currentPage?.learnMoreText }}</Button
      >
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, Ref, watch, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAuthModals } from '@/composables/useAuthModals';
import { TrackEvents, useTrack } from '@/composables/useTrack';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useLayoutStore } from '@/store/useLayoutStore';
import { LandingItem, LandingPages, useLandingStore } from './store/useLandingStore';
import Button from '@/storybook/button/Button.vue';

const props = defineProps<{
  type: LandingPages;
}>();

const route = useRoute();

const landingStore = useLandingStore();
const layoutStore = useLayoutStore();
const itemStore = useViewerItemStore();

const currentPage: Ref<LandingItem | null> = ref(null);
currentPage.value = landingStore.getByType(props.type);

const { showSignUpModal } = useAuthModals();
const { track } = useTrack();
const { id } = storeToRefs(itemStore);

const signUpClick = () => {
  track(TrackEvents.SIGN_UP_CLICK, { route: route.meta?.title, viewer: 'copernicus', hashid: id?.value });

  showSignUpModal();
};

onMounted(() => {
  layoutStore.hideCta();
  layoutStore.showBackButton();
});
onUnmounted(() => {
  layoutStore.showCta();
  layoutStore.hideBackButton();
});

watch(
  () => props.type,
  val => {
    currentPage.value = landingStore.getByType(val);
  }
);
</script>
